import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@lib/cn"

export const textareaVariants = cva(
  [
    "ui-control",
    "block w-full rounded-md py-2 px-3",
    "bg-white text-cloverhound-gray-900 placeholder:text-cloverhound-gray-600",
    "dark:bg-cloverhound-gray-900 dark:text-cloverhound-gray-50 dark:placeholder:text-cloverhound-gray-500",
    "border border-cloverhound-gray-300 dark:border-cloverhound-gray-800",
    "transition-colors duration-quick ease-out-quad motion-reduce:transition-none",
    "focus:outline-none focus:border-cloverhound-indigo-400 focus:ring-2 focus:ring-cloverhound-indigo-500/30",
    "disabled:cursor-not-allowed disabled:opacity-70",
    "disabled:bg-cloverhound-gray-100 dark:disabled:bg-cloverhound-gray-950",
  ].join(" "),
  {
    variants: {
      state: {
        default: "",
        error: "border-cloverhound-red-500 dark:border-cloverhound-red-500 focus:border-cloverhound-red-500 focus:ring-cloverhound-red-500/30",
      },
      resize: {
        none: "resize-none",
        y: "resize-y",
        both: "resize",
      },
    },
    defaultVariants: { state: "default", resize: "y" },
  },
)

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, state, resize, ...props }, ref) => (
    <textarea ref={ref} className={cn(textareaVariants({ state, resize }), className)} {...props} />
  ),
)
Textarea.displayName = "Textarea"
